import React from "react";
import ReactDOM from "react-dom";
import {AppContainer} from "react-hot-loader";
import { Plugins } from '@capacitor/core';

import {App} from "./code/app";
import {SENTRY_API_URL} from "./code/shared/constants/api";

require("./style/sass/styles.scss");

Sentry.init({dsn: SENTRY_API_URL});
Plugins.SplashScreen.hide();

ReactDOM.render(
  <AppContainer>
    <App />
  </AppContainer>,
  document.getElementById("index")
);
